import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as _ from 'underscore';
import { API_BIO_URL, GEOSERVER_URL } from 'src/environments/environment';
import { AlertsVisualizationFilter } from '../../interfaces/alerts-visualization-filter.interface';
import { formatVisualizationFilterPayload } from '../../utils/format-filter-params';
import { map } from 'rxjs';
import { AlertRefined } from '../../entities/alert-refined.entity.';
import { ALERT_VALIDATION_LAYER, GEOSERVER_WORKSPACE } from '../../constants';
import { Feature, FeatureCollection, Geometry, Polygon } from 'geojson';
import API_URL from '../../utils/api-url-homolog';


@Injectable({
  providedIn: 'root'
})


export class AlertFilterOptionsService {

  // private apiUrl = 'https://bfkts3jaswinpvxy12014.cleavr.one/api/estados'; // URL da API para a lista de estados
  getTerritoryOptions: any;

  constructor(private http: HttpClient) { }
  /**
   * Gets alert detetection classes options
   */
  async getDataLayerOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/alert/datalayers/list/`).toPromise();
  }

  /**
   * Gets alert detetection classes options
   */
  async getDetectionClassesOptions(params: AlertsVisualizationFilter): Promise<any[]> {
    const filterPayload = formatVisualizationFilterPayload(params);
    delete filterPayload.alertClass;
    return this.http.post<any>(`${API_URL}/alert/classes/list/`, filterPayload).toPromise();
  }


  /**
   * Gets alert cities options - acaz
   */

async getAllOptions(params: AlertsVisualizationFilter): Promise<any[]> {
  const filterPayload = formatVisualizationFilterPayload(params);
  delete filterPayload.citiesIdList;
  const selectedRoute = params.territoryId
  console.log('Territory inside GetALLOption',params);
  return this.http.get<any[]>(`${API_BIO_URL}/${selectedRoute}`).toPromise();
}

/**
 * Get filter
 */

async getTerritorySelectedOption(id: string, territoryCategory: string): Promise<any[]> {
  return this.http.get<any[]>(`${API_BIO_URL}/${territoryCategory}/${id}`).toPromise();
}

  async getTerritoryGroupOption(params: AlertsVisualizationFilter): Promise<any[]> {
  const filterPayload = formatVisualizationFilterPayload(params);
  // delete filterPayload.TerritoryGroupOptions;
  const queryParams = new URLSearchParams(filterPayload as any).toString();

  return this.http.get<any[]>(`${API_BIO_URL}/agrupamentoTeritorial`).toPromise();
}

  /**
   * Gets Has Embargoed Areas options
   */
  async getHasEmbargoedAreasOptions(params: AlertsVisualizationFilter): Promise<any[]> {
    const filterPayload = formatVisualizationFilterPayload(params);
    delete filterPayload.embargoed;
    return this.http.post<any>(`${API_URL}/alert/embargoed/list`, filterPayload).toPromise();
  }



  /**
   * Gets sources options
   */
  async getSourcesOptions(params: AlertsVisualizationFilter): Promise<any[]> {
    const filterPayload = formatVisualizationFilterPayload(params);
    delete filterPayload.sourceList;
    return this.http.post<any>(`${API_URL}/alert/source/list`, filterPayload).toPromise();
  }


  /**
   * Gets sources options
   */
  async getSensorsOptions(params: AlertsVisualizationFilter): Promise<any[]> {
    const filterPayload = formatVisualizationFilterPayload(params);
    delete filterPayload.sourceList;
    return this.http.post<any>(`${API_URL}/alert/sensor/list`, filterPayload).toPromise();
  }

  /**
   * Gets has validation options
   */
  async getHasValidationOptions(params: AlertsVisualizationFilter): Promise<any[]> {
    const filterPayload = formatVisualizationFilterPayload(params);
    delete filterPayload.validation;
    return this.http.post<any>(`${API_URL}/alert/validation/list`, filterPayload).toPromise();
  }

  /**
   * Gets has authorization options
  */
  async getHasAuthorizationOptions(params: AlertsVisualizationFilter): Promise<any[]> {
    const filterPayload = formatVisualizationFilterPayload(params);
    delete filterPayload.authorized;
    return this.http.post<any>(`${API_URL}/alert/authorization/list`, filterPayload).toPromise();
  }

  /**
   * Gets has car options
   */
  async getHasCarOptions(params: AlertsVisualizationFilter): Promise<any[]> {
    const filterPayload = formatVisualizationFilterPayload(params);
    return this.http.post<any>(`${API_URL}/alert/car/list`, filterPayload).toPromise();
  }

  /**
   * Gets has supervision options
   */
  async getHasSupervisionOptions(params: AlertsVisualizationFilter): Promise<any[]> {
    const filterPayload = formatVisualizationFilterPayload(params);
    delete filterPayload.supervision;
    return this.http.post<any>(`${API_URL}/alert/supervision/list`, filterPayload).toPromise();
  }

  /**
   * Gets has sizerange options
   */
  async getSizeRangeOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/alert/sizerange/list`).toPromise();
  }

  /**
   * Gets has biome options
   */
  async getBiomeOptions(params: AlertsVisualizationFilter): Promise<any[]> {
    const filterPayload = formatVisualizationFilterPayload(params);
    delete filterPayload.biomeList;
    return this.http.post<any>(`${API_URL}/alert/biome/list`, filterPayload).toPromise();
  }

  /**
    * Gets has ancient vegetation options
    */
  async getAncientVegetationOptions(params: AlertsVisualizationFilter): Promise<any[]>{
    const filterPayload = formatVisualizationFilterPayload(params);
    delete filterPayload.ancientVegetation;
    return this.http.post<any>(`${API_URL}/alert/ancientvegetation/list`, filterPayload).toPromise();
  }

  async getValidatedClassesOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/validation/validatedclasses/list`).toPromise();
  }

  async getChargableOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/validation/fine/list`)
      .pipe(map(response => {
        response.forEach((item: { value: string; id: number; }) => {
          if (item.value == 'Sim') {
            item.id = 1;
          } else {
            item.id = 0;
          }
        })
        return response;
      }))
      .toPromise();
  }

  async getFeedbackOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/validation/feedback/list`).toPromise()
      .then(response => {
        return response.sort((a: any, b: any) => a.id > b.id ? 1 : -1);
      })
      .then(response => {
        return response.map((a: any) => {
          a.id == 99 ? (a.id = 99) : null;
          a.id == 21 ? (a.id = 99) : null;
          return a;
        });
      })
      .then(response => {
        return _.uniq(response, (item) => item.id);
      });
  }

  async getObservationOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/validation/observation/list`).toPromise()
    .then(response => {
      return response.sort((a: any, b: any) => a.id > b.id ? 1 : -1);
    })
    .then(response => {
      return response.map((a: any) => {
        a.id == 99 ? (a.id = 99) : null;
        a.id == 23 ? (a.id = 99) : null;
        return a;
      });
    })
    .then(response => {
      return _.uniq(response, (item) => item.id);
    });
  }

  async getStatusOptions(): Promise<any[]> {
    return this.http.get<any>(`${API_URL}/validation/status/list`).toPromise();
  }

  async getAlertById(id: number): Promise<AlertRefined> {
    return this.http.post<AlertRefined[]>(`${API_URL}/alert/validation/map/select`, { alertId: id })
      .pipe(map(response => response[0]))
      .toPromise();
  }

  async getPreviousAlertId(id: number) {
    const payload = {
      service: 'WFS',
      version: '1.0.0',
      request: 'GetFeature',
      typeName: ALERT_VALIDATION_LAYER,
      maxFeatures: '1',
      sortBy: 'ALERT_ID D',
      outputFormat: 'application/json',
      CQL_FILTER: `ALERT_ID < ${id}`,
    };
    const httpParams = new HttpParams({
      fromObject: payload
    });
    const featuresCol = await this.http.get<FeatureCollection>(`${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows`, { params: httpParams }).toPromise();
    return featuresCol.features[0].properties['ALERT_ID'] as number;
    //return this.http.post<any>(`${API_URL}/alert/validation/previousid`, { alertId: id }).toPromise();
  }

  async getNextAlertId(id: number) {
    const payload = {
      service: 'WFS',
      version: '1.0.0',
      request: 'GetFeature',
      typeName: ALERT_VALIDATION_LAYER,
      maxFeatures: '1',
      outputFormat: 'application/json',
      CQL_FILTER: `ALERT_ID > ${id}`,
    };
    const httpParams = new HttpParams({
      fromObject: payload
    });
    const featuresCol = await this.http.get<FeatureCollection>(`${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows`, { params: httpParams }).toPromise();
    return featuresCol.features[0].properties['ALERT_ID'] as number;
    //return this.http.post<any>(`${API_URL}/alert/validation/nextid`, { alertId: id }).toPromise();
  }

  async getWfsFeatureById(id: number): Promise<Feature<Geometry>> {
    const payload = {
      service: 'WFS',
      version: '1.0.0',
      request: 'GetFeature',
      typeName: ALERT_VALIDATION_LAYER,
      outputFormat: 'application/json',
      CQL_FILTER: `ALERT_ID = ${id}`,
    };
    const httpParams = new HttpParams({
      fromObject: payload
    });
    const featuresCol = await this.http.get<FeatureCollection>(`${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows`, { params: httpParams }).toPromise();
    return featuresCol.features[0] as Feature<Geometry>;
  }

  async getWfsRawFeatureById(id: number): Promise<Feature<Geometry>> {
    const payload = {
      service: 'WFS',
      version: '1.0.0',
      request: 'GetFeature',
      typeName: 'GEOSERVER_ALERT_RAW',
      outputFormat: 'application/json',
      CQL_FILTER: `ALERT_ID = ${id}`,
    };
    const httpParams = new HttpParams({
      fromObject: payload
    });
    const featuresCol = await this.http.get<FeatureCollection>(`${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows`, { params: httpParams }).toPromise();
    return featuresCol.features[0] as Feature<Geometry>;
  }

  async getWfsProcessedFeatureById(id: number): Promise<Feature<Geometry>> {
    const payload = {
      service: 'WFS',
      version: '1.0.0',
      request: 'GetFeature',
      typeName: 'GEOSERVER_ALERT_PROCESSED',
      outputFormat: 'application/json',
      CQL_FILTER: `ALERT_ID = ${id}`,
    };
    const httpParams = new HttpParams({
      fromObject: payload
    });
    const featuresCol = await this.http.get<FeatureCollection>(`${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows`, { params: httpParams }).toPromise();
    return featuresCol.features[0] as Feature<Geometry>;
  }
}

